<template>
    <div id="withdrawalLog">
        <Header :title="title" />

        <main class="MainCon bottom0">
            <div class="h100">
                <IScroll @loadBottom="fetchWithdrawalLogList" ref="scroll" id="scrollWrap">
                    <template v-if="app.template.type === '92fanli'">
                        <NTfanliWithdrawalLog :style-name="app.template.style"
                                              :list="withdrawalLogData.list" />
                    </template>
                    <template v-else-if="app.template.type === 'damai'">
                        <DamaiWithdrawalLog :style-name="app.template.style"
                                            :list="withdrawalLogData.list" />
                    </template>
                    <template v-else>
                        <IfanliWithdrawalLog :style-name="app.template.style"
                                             :list="withdrawalLogData.list" />
                    </template>
                </IScroll>
            </div>
        </main>

        <div class="goTopBtn">
            <img v-if="btnFlag" src="@/assets/images/backTop.png" v-on:click="toTop">
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import IScroll from '../components/IScroll';
    import IfanliWithdrawalLog from './ifanli/WithdrawalLog';
    import NTfanliWithdrawalLog from './92fanli/WithdrawalLog';
    import DamaiWithdrawalLog from './damai/WithdrawalLog';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {
            IScroll,
            IfanliWithdrawalLog,
            NTfanliWithdrawalLog,
            DamaiWithdrawalLog,
            Header
        },
        data() {
            return {
                title: '提现明细',
                withdrawalLogData: {
                    empty: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 0
                },
                btnFlag: false,
            }
        },
        computed: {
            ...mapState(['app']),
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/user';
            }
            this.fetchWithdrawalLogList({init: true});
        },
        updated() {
            document.getElementById('scrollWrap').addEventListener('scroll', this.scrollToTop)
        },
        methods: {
            fetchWithdrawalLogList: function ({init = false} = {}) {
                let self = this;

                if (self.withdrawalLogData.isMore === true && self.withdrawalLogData.loading === false) {
                    self.withdrawalLogData.loading = true;

                    appService.fetchWithdrawalLogList({
                        pageNum: self.withdrawalLogData.pageNum
                    }).then((res) => {
                        let {code, data} = res;
                        if (code === 1) {
                            if (data['data'] !== null && data['data'].length > 0) {
                                if (init) {
                                    self.$refs.scroll.toTop(0);
                                    self.withdrawalLogData.list = data['data']
                                } else {
                                    for (let i = 0; i < data['data'].length; i++) {
                                        self.withdrawalLogData.list.push(data['data'][i]);
                                    }
                                }
                                self.withdrawalLogData.isMore = true;
                                self.withdrawalLogData.pageNum++;
                            } else {
                                if (self.withdrawalLogData.list.length > 0) {
                                    self.withdrawalLogData.isMore = false;
                                } else {
                                    self.withdrawalLogData.empty = true;
                                }
                            }
                        }
                        self.withdrawalLogData.loading = false;
                    });
                }
            },
            scrollToTop: function () {
                this.btnFlag = document.getElementById('scrollWrap').scrollTop > 180;
            },
            toTop: function () {
                this.$refs.scroll.toTop(0);
            }
        }
    }
</script>

<style scoped>

</style>
